import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'waitTime',
  standalone: true
})
export class WaitTimePipe implements PipeTransform {

  transform(value: number): number {
    if (!value || isNaN(value)) return 0;

    const minutes = value / 60;

    if (minutes <= 5) {
      return Math.ceil(minutes);
    } else {
      return Math.ceil(minutes / 5) * 5;
    }
  }
}